import { MAIN, ROOT_URL } from "../../../routes/constants";
import OrderList from "./OrderList";
import OrderMonthly from "./OrderMonthly";

//Module Page Routes
export const ORDER_LIST = MAIN + "/PartnerOrders";
export const ORDER_MONTHLY = ORDER_LIST + "/monthly";

const MobileContactRoutes = [
    {
        label: "PARTNER ORDERS",
        path: [ORDER_LIST,ROOT_URL],
        component: OrderList,
        exact: true,
        mainscreen: true
    },
    {
        label: "MONTHLY ORDERS",
        path: ORDER_MONTHLY + "/:id?",
        component: OrderMonthly,
        exact: true,
    },
];

export default MobileContactRoutes;